import { useMutation } from '@tanstack/react-query';
import { apiAxios } from '../axios';
import type { UserSuccessOutput } from '../../generated/fresh-guard-api';

export interface ChangeOwnPasswordInput {
  currentPassword: string;
  newPassword: string;
}

export function useChangeOwnPassword() {
  return useMutation({
    mutationFn: async (input: ChangeOwnPasswordInput) => {
      const res = await apiAxios.put<UserSuccessOutput>('/api/profile_change_password', input);
      return res.data;
    },
    meta: {
      skipGlobalError: false,
    },
  });
}
